(function () {
  class GambleSpin extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;

      this._collectButton = undefined;
      this._bonusArrow = undefined;
      this._gambleDisc = undefined;
      this._winAnim = undefined;
      this._touchToGamble = undefined;
      this._pointerFinger = undefined;

      this._initWinnings = 0;
      this._currentCashWinnings = 0;
      this._winCapped = 0;

      this.moveFinger = false;
      this.fingerMoving = false;
      this.fingerTimer = undefined;

      this._bonusWinStartAngle = undefined;
      this._bonusWinEndAngle = undefined;
      this._loseStartAngle = undefined;
      this._bonusLoseEndAngle = undefined;

      this._currentWin = 0;

      this._pulseTween = undefined;

      this._selectSounds = ['gambleDecrease', 'gambleIncrease'];

      this._bonusEmitter = undefined;
      this._cashEmitter = undefined;

      this._hasGambled = false;

      this._bonusOptions = undefined;
      this._cashOptions = undefined;

      this._callback = undefined;

      this._collected = false;
      this._buttonsActive = false;

      this._recover = false;
      this._recoverSubsequent = false;
      this._removeRecovery = false;

      // this._spinnerTimeline = undefined;

      this._currentBonusLevel = 0;
      this._maxBonusLevel = 0;
      this._nextFreeSpins = 0;
      this._bonusAvailable = true;
      this._cashAvailable = true;
      this._bonusCommands = ['GAMBLE_BONUS_0', 'GAMBLE_BONUS_1', 'GAMBLE_BONUS_2', 'GAMBLE_BONUS_3', 'GAMBLE_BONUS_4'];
      this._cashCommands = ['GAMBLE_CASH_0', 'GAMBLE_CASH_1', 'GAMBLE_CASH_2', 'GAMBLE_CASH_3', 'GAMBLE_CASH_4'];

      this._currentPrizeType = 'cash';
      this._maxCashLevel = 0;
      this._currentCashLevel = 0;
      this._nextCash = 0;

      this._bonusGambleOptionTexts = [];
      this._bonusGambleOptionPanels = [];
      this._cashGambleOptionTexts = [];
      this._cashGambleOptionPanels = [];
      this._bonusGambleOptionPanelEmitters = [];
      this._cashGambleOptionPanelEmitters = [];

      this._commandCheck = false;

      let self = this;
      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState('IDLE', function () {});
    }

    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });

      messageBus.subscribe('spinner:GambleDataEvent', this.onGambleDataEvent.bind(this));
      messageBus.subscribe('spinner:GambleDataEventDead', this.onGambleDataEventEnd.bind(this));
      messageBus.subscribe('spinner:GambleResultEvent', this.onGambleResultEvent.bind(this));
      messageBus.subscribe('spinner:GambleCommandSent', this.onCommandSent.bind(this));
      messageBus.subscribe('common:RecoverGame', this.recoverGame.bind(this));
      messageBus.subscribe('Gamble:RemoveRecoveryFlag', this.removeRecoveryFlag.bind(this));
    }

    recoverGame() {
      if (this._removeRecovery) {
        return;
      }

      this._recover = true;
      this._recoverSubsequent = false;
    }

    removeRecoveryFlag() {
      this._recover = false;
      this._recoverSubsequent = false;
      this._removeRecovery = true;

      this._collectButton.visible = true;
      this._collectButton.interactive = true;

      this.enableBonusGambleOptions();
      this.enableCashGambleOptions();

      this.checkDirectionButton('bonus');
      this.checkDirectionButton('cash');
    }

    onGambleDataEventEnd() {
      if (!this._collected) {
        gdk.getNextGameOutcome(function () {});
      }
    }

    onCommandSent() {
      if (this._commandCheck) {
        gdk.getNextGameOutcome(function () {});
        this._commandCheck = false;
      }
    }

    readyForResult() {}

    onGambleDataEvent(task) {
      task.join();

      this._collected = false;
      this._commandCheck = false;

      this._currentPrizeType = 'cash';

      this.checkPrepareGamble(task);
    }

    onGambleResultEvent(task) {
      if (this._hasGambled) {
        const self = this;
        let temp = task;
        temp.join();

        // musicManager.gambleSpin();

        this.spinToResult(task, function () {
          temp.leave();
          temp = undefined;
          self._resultShownCb = undefined;
        });
      }
    }

    checkPrepareGamble(task) {
      if (
        !gdk.getPlatformAllowsGamble() ||
        gameController.gambleMode === 'off' ||
        (task.data.bonusGambleOptions.length === 0 && task.data.cashGambleOptions.length === 0) || // no gamble options
        task.data.isCapped
      ) {
        this.onDecisionMade(task, task.data.resultCallback, 'COLLECT');
        return;
      } else if (gameController.gambleMode === 'five') {
        if (gameController.totalWinnings < resourceManager.getController('stakeController').BaseStake * 5) {
          this.onDecisionMade(task, task.data.resultCallback, 'COLLECT');
          return;
        }
      }

      timerManager.addTimeout(800, () => {
        this.prepareGamble(task);
      });
    }

    prepareGamble(task) {
      this.setButtonActive(this._bonusPrev, true);
      this.setButtonActive(this._bonusNext, true);
      this.setButtonActive(this._cashPrev, true);
      this.setButtonActive(this._cashNext, true);

      resourceManager.get('gambleBacker').visible = false;

      this._collectButton.alpha = 1;

      this._recoverSubsequent = false;

      this._currentBonusLevel = 0;
      this._currentCashLevel = 1;

      this._bonusArrow.rotation = Math.PI / 2;
      this._cashArrow.rotation = Math.PI / 2;

      this._callback = this.onDecisionMade.bind(this, task, task.data.resultCallback);

      this.prepareOptions(this._currentBonusLevel, this._currentCashLevel, task.data);

      this.start(task.data.bonusGambleOptions, task.data.cashGambleOptions, true);

      this.enterAnim();

      this.setCurrentPrize('cash', gameController.totalWinnings);

      this._initWinnings = gameController.totalWinnings;
      this._currentCashWinnings = gameController.totalWinnings;
    }

    onDecisionMade(task, resultCallback, gambleDecision) {
      resultCallback({ response: gambleDecision }, function () {
        task.leave();
      });
    }

    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }

      if (this.moveFinger && !this.fingerMoving) {
        let self = this;
        this.fingerMoving = true;
        timerManager.addTimer(
          1000,
          function (progress) {
            self._pointerFinger.position.setX(self.fingerStartX + 20 * Math.abs(Math.sin(Math.PI * progress)));
          },
          function () {
            self.fingerMoving = false;
          }
        );
      }
    }

    onLayoutComplete() {
      this._gambleScreen = resourceManager.get('gambleSpinContainer:GambleSpin');
      this._touchToGambleText = resourceManager.get(
        'gambleSpinContainer:GambleSpin:gamblePanel:touchToGambleContainer'
      );

      this._resultText = resourceManager.get('gambleSpinContainer:GambleSpin:resultMessage');
      this._resultText.renderable = false;
      this._resultTextP = resourceManager.get('gambleSpinContainer:GambleSpin:resultMessageP');
      this._resultTextP.renderable = false;

      this._bonusGamble = resourceManager.get('gambleSpinContainer:GambleSpin:bonusGamble');
      this._bonusGambleText = resourceManager.get('gambleSpinContainer:GambleSpin:bonusButtons:numFreeSpinsText');

      this._bonusPrev = resourceManager.get('gambleSpinContainer:GambleSpin:bonusButtons:prevButton');
      this._bonusPrev.mousedown = () => this.selectButtonPressed('bonus', -1);
      this._bonusPrev.touchstart = () => this.selectButtonPressed('bonus', -1);

      this._bonusNext = resourceManager.get('gambleSpinContainer:GambleSpin:bonusButtons:nextButton');
      this._bonusNext.mousedown = () => this.selectButtonPressed('bonus', 1);
      this._bonusNext.touchstart = () => this.selectButtonPressed('bonus', 1);

      this._bonusArrow = resourceManager.get('gambleSpinContainer:GambleSpin:bonusGamble:gambleArrow');
      this._bonusSpinnerBacking = resourceManager.get(
        'gambleSpinContainer:GambleSpin:bonusGamble:gambleSegmentsBacking'
      );
      this._bonusSpinnerBacking.alpha = 0;
      this._bonusSpinner = resourceManager.get('gambleSpinContainer:GambleSpin:bonusGamble:gambleSegments');
      this._bonusSpinner.mousedown = () => this.onCommittedToGamble('bonus');
      this._bonusSpinner.touchstart = () => this.onCommittedToGamble('bonus');

      this._cashGamble = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble');
      this._cashGambleText = resourceManager.get('gambleSpinContainer:GambleSpin:cashButtons:cashText');

      this._cashPrev = resourceManager.get('gambleSpinContainer:GambleSpin:cashButtons:prevButton');
      this._cashPrev.mousedown = () => this.selectButtonPressed('cash', -1);
      this._cashPrev.touchstart = () => this.selectButtonPressed('cash', -1);

      this._cashNext = resourceManager.get('gambleSpinContainer:GambleSpin:cashButtons:nextButton');
      this._cashNext.mousedown = () => this.selectButtonPressed('cash', 1);
      this._cashNext.touchstart = () => this.selectButtonPressed('cash', 1);

      this._cashArrow = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble:gambleArrow');
      this._cashSpinner = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble:gambleSegments');
      this._cashSpinnerBacking = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble:gambleSegmentsBacking');
      this._cashSpinnerBacking.alpha = 0;
      this._cashSpinner.mousedown = () => this.onCommittedToGamble('cash');
      this._cashSpinner.touchstart = () => this.onCommittedToGamble('cash');

      this._currentPrizeText = resourceManager.get(
        'gambleSpinContainer:GambleSpin:collectionPanel:collectionPanelText'
      );

      this._collectButton = resourceManager.get('gambleSpinContainer:GambleSpin:collectButton');
      this._collectButton.mousedown = this._collectButton.touchstart = this.onClickedToContinue.bind(this);

      this._gambleContainer = resourceManager.getContainer('gambleIntroContainer');
      // this._gambleDisclaimer = resourceManager.get('gambleDisclaimerContainer:GambleDisclaimer');

      this._bonusWinText = resourceManager.get('gambleSpinContainer:GambleSpin:bonusGamble:win');
      this._bonusLoseText = resourceManager.get('gambleSpinContainer:GambleSpin:bonusGamble:lose');
      this._cashWinText = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble:win');
      this._cashLoseText = resourceManager.get('gambleSpinContainer:GambleSpin:cashGamble:lose');
      this._bonusWinText.visible = false;
      this._bonusLoseText.visible = false;
      this._cashWinText.visible = false;
      this._cashLoseText.visible = false;

      // this._upgrade1 = resourceManager.get('gambleSpinContainer:GambleSpin:bonusButtons:upgrade1');
      // this._upgrade2 = resourceManager.get('gambleSpinContainer:GambleSpin:bonusButtons:upgrade2');
      // this._upgrade1.visible = false;
      // this._upgrade2.visible = false;

      for (let i = 0; i < this._bonusCommands.length; i++) {
        this._bonusGambleOptionPanels[i] = resourceManager.get(
          `gambleSpinContainer:GambleSpin:bonusBeanstalk:bonusOption${i}Panel`
        );
        this._bonusGambleOptionPanels[i].gotoAndStop(0);
        this._bonusGambleOptionTexts[i] = resourceManager.get(
          `gambleSpinContainer:GambleSpin:bonusBeanstalk:bonusOption${i}Panel:bonusOption${i}Text0`
        );
      }

      for (let i = 0; i < this._cashCommands.length; i++) {
        this._cashGambleOptionPanels[i] = resourceManager.get(
          `gambleSpinContainer:GambleSpin:cashBeanstalk:cashOption${i}Panel`
        );
        this._cashGambleOptionPanels[i].gotoAndStop(0);
        this._cashGambleOptionTexts[i] = resourceManager.get(
          `gambleSpinContainer:GambleSpin:cashBeanstalk:cashOption${i}Panel:cashOption${i}Text0`
        );
      }

      // lets create hit areas for the panels,
      // and assign a callback
      for (let i = 0; i < this._bonusGambleOptionPanels.length; i++) {
        this._bonusGambleOptionPanels[i].hitArea = new PIXI.Circle(0, 0, 34);
        this._bonusGambleOptionPanels[i].mousedown = this._bonusGambleOptionPanels[i].touchstart = () => {
          this.onBonusGambleOptionPressed(i);
        };
        this._bonusGambleOptionPanels[i].interactive = false;
        // if (Reflex.developerModeData.showButtonHitAreas) {
        //   this._bonusGambleOptionPanels[i].graphics = new PIXI.Graphics();
        //   this._bonusGambleOptionPanels[i].graphics.beginFill(0xff0008);
        //   this._bonusGambleOptionPanels[i].graphics.lineStyle(4, 0xff0008, 1);
        //   this._bonusGambleOptionPanels[i].graphics.drawCircle(0, 0, 34);
        //   this._bonusGambleOptionPanels[i].graphics.endFill();
        //   this._bonusGambleOptionPanels[i].graphics.alpha = 0.5;
        //   this._bonusGambleOptionPanels[i].addChild(this._bonusGambleOptionPanels[i].graphics);
        // }
      }

      for (let i = 0; i < this._cashGambleOptionPanels.length; i++) {
        this._cashGambleOptionPanels[i].hitArea = new PIXI.Circle(0, 0, 34);
        this._cashGambleOptionPanels[i].mousedown = this._cashGambleOptionPanels[i].touchstart = () => {
          this.onCashGambleOptionPressed(i);
        };
        this._cashGambleOptionPanels[i].interactive = false;
        // if (Reflex.developerModeData.showButtonHitAreas) {
        //   this._cashGambleOptionPanels[i].graphics = new PIXI.Graphics();
        //   this._cashGambleOptionPanels[i].graphics.beginFill(0xff0008);
        //   this._cashGambleOptionPanels[i].graphics.lineStyle(4, 0xff0008, 1);
        //   this._cashGambleOptionPanels[i].graphics.drawCircle(0, 0, 34);
        //   this._cashGambleOptionPanels[i].graphics.endFill();
        //   this._cashGambleOptionPanels[i].graphics.alpha = 0.5;
        //   this._cashGambleOptionPanels[i].addChild(this._cashGambleOptionPanels[i].graphics);
        // }
      }

      this._pulseTween = gsap.to(this._touchToGambleText.scale, {
        duration: 0.8,
        x: 1.1,
        y: 1.1,
        yoyo: true,
        repeat: -1,
        ease: 'power1.inOut',
      });

      this._cashSpinnerBacking.beginFill(0x000000);
      this._cashSpinnerBacking.lineStyle(0, 0x000000);
      this._cashSpinnerBacking.moveTo(0, 0);
      this._cashSpinnerBacking.arc(0, 0, 125, 0, Math.PI * 2);
      this._cashSpinnerBacking.endFill();

      this._bonusSpinnerBacking.beginFill(0x000000);
      this._bonusSpinnerBacking.lineStyle(0, 0x000000);
      this._bonusSpinnerBacking.moveTo(0, 0);
      this._bonusSpinnerBacking.arc(0, 0, 125, 0, Math.PI * 2);
      this._bonusSpinnerBacking.endFill();

      this._bonusEmitter = particleManager.createEmitter(
        'gamble_emitter',
        'gambleSpinContainer:GambleSpin:bonusGamble:particlesContainer',
        0,
        0,
        false
      );
      this._bonusEmitter.particleEmitter.emit = false;

      this._cashEmitter = particleManager.createEmitter(
        'gamble_emitter',
        'gambleSpinContainer:GambleSpin:cashGamble:particlesContainer',
        0,
        0,
        false
      );
      this._cashEmitter.particleEmitter.emit = false;

      for (let i = 0; i < this._bonusCommands.length; i++) {
        this._bonusGambleOptionPanelEmitters[i] = particleManager.createEmitter(
          'gamble_option_emitter',
          `gambleSpinContainer:GambleSpin:bonusBeanstalk:bonusOption${i}Panel`,
          0,
          0,
          false
        );
        this._bonusGambleOptionPanelEmitters[i].particleEmitter.emit = false;
      }

      for (let i = 0; i < this._cashCommands.length; i++) {
        this._cashGambleOptionPanelEmitters[i] = particleManager.createEmitter(
          'gamble_option_emitter',
          `gambleSpinContainer:GambleSpin:cashBeanstalk:cashOption${i}Panel`,
          0,
          0,
          false
        );
        this._cashGambleOptionPanelEmitters[i].particleEmitter.emit = false;
      }

      messageBus.subscribe('Gamble:Risk', this.onGambleRisk.bind(this));
      messageBus.subscribe('Gamble:Collect', this.onGambleCollect.bind(this));
      messageBus.subscribe('Gamble:ClickToContinue', this.onClickedToContinue.bind(this));

      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
    }

    onBonusGambleOptionPressed(index) {
      if (index !== this._currentBonusLevel) {
        if (index < this._currentBonusLevel) {
          soundManager.play('gambleDecrease');
        } else {
          soundManager.play('gambleIncrease');
        }
        this._currentBonusLevel = index;
        this.highlightBonusOption(this._currentBonusLevel);
        this._nextFreeSpins = this._bonusOptions[this._currentBonusLevel].freeSpinsWon;

        if (this._bonusAvailable) {
          this._bonusGambleText.setTranslationParameters(this._nextFreeSpins);
        } else {
          this._bonusGambleText.setText('');
        }
        this.checkDirectionButton('bonus');
        this.setupWheel();
      }
    }

    onCashGambleOptionPressed(index) {
      if (index !== this._currentCashLevel) {
        if (index < this._currentCashLevel) {
          soundManager.play('gambleDecrease');
        } else {
          soundManager.play('gambleIncrease');
        }

        this._currentCashLevel = index;
        this.highlightCashOption(this._currentCashLevel);
        this._nextCash = this._cashOptions[this._currentCashLevel].winAmount;

        if (this._cashAvailable) {
          this._cashGambleText.setText(gdk.formatCurrency(this._nextCash));
        } else {
          this._cashGambleText.setText('');
        }
        this.checkDirectionButton('cash');
        this.setupWheel();
      }
    }

    disableCashGambleOptions() {
      for (let i = 0; i < this._cashGambleOptionPanels.length; i++) {
        this._cashGambleOptionPanels[i].interactive = false;
      }
    }

    disableBonusGambleOptions() {
      for (let i = 0; i < this._bonusGambleOptionPanels.length; i++) {
        this._bonusGambleOptionPanels[i].interactive = false;
      }
    }

    enableCashGambleOptions() {
      if (!this._recover) {
        for (let i = 0; i < this._cashGambleOptionPanels.length; i++) {
          this._cashGambleOptionPanels[i].interactive = true;
        }
      }
    }

    enableBonusGambleOptions() {
      if (!this._recover) {
        for (let i = 0; i < this._bonusGambleOptionPanels.length; i++) {
          this._bonusGambleOptionPanels[i].interactive = true;
        }
      }
    }

    onOrientationChange() {
      // this._spinnerTimeline?.pause();
      //   const currentLayout = layoutController.getCurrentLayout();
      //   const landscape = currentLayout.includes('landscape');
      //   const mobile = currentLayout.includes('mobile');
    }

    toggleTouchText(show) {
      this._touchToGambleText.alpha = show ? 1 : 0.5;

      if (show) {
        this._pulseTween.play(0);
      } else {
        this._pulseTween.pause(0);
      }
    }

    onGambleCollect() {
      if (!this.visible) return;

      soundManager.play('gambleCollect');

      this.disableBonusGambleOptions();
      this.disableCashGambleOptions();

      this._collected = true;
      this._collectButton.interactive = false;
      this._commandCheck = true;
      this._hasGambled = false;

      // clear the total win before the anims have started
      if (this._currentPrizeType === 'bonus') {
        gameController.totalWinnings = 0;
        gameController.fullGameWinnings = 0;
        gameData.winningsMeter.set(gameController.totalWinnings);
      } else {
        gameData.winningsMeter.set(this._currentCashWinnings);
        gameController.totalWinnings = this._currentCashWinnings;
        gameController.fullGameWinnings = this._currentCashWinnings;
      }

      this.exitAnim(() => {
        this.onGambleCollectAnimationsDone();
      });
    }

    onGambleCollectAnimationsDone() {
      this.alpha = 1;
      this.visible = false;

      if (this._currentPrizeType === 'bonus') {
        this.end();
      } else {
        // should we show the max win pop up here if we auto collected the top prize
        this.checkBigwin();
      }
    }

    async showMaxGambleReachedPopup(extraDelay) {
      const maxWinPopup = resourceManager.get('maxGambleWinReachedPopup');
      const pressStartBox = resourceManager.get('maxGambleWinReachedPopup:pressStartColourBox');

      pressStartBox.interactive = false;

      if (extraDelay > 0) {
        await timerManager.delayAsync(extraDelay);
      }

      maxWinPopup.visible = true;
      await game.tweenFromToAsync(maxWinPopup, { alpha: 0 }, { alpha: 1, duration: 0.5 });

      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      pressStartBox.mousedown = pressStartBox.touchstart = () => {
        pressStartBox.interactive = false;
        resolver();
      };

      pressStartBox.interactive = true;

      await promise;

      pressStartBox.mousedown = pressStartBox.touchstart = undefined;

      await game.tweenFromToAsync(maxWinPopup, { alpha: 1 }, { alpha: 0, duration: 0.25 });

      maxWinPopup.visible = false;
    }

    async checkBigwin() {
      const bigWin = resourceManager.get('bigWin:BigWin');
      let showBigWin = false;

      const aboveStake = this._currentCashWinnings > this._initWinnings;
      // SRB TODO !!!!
      const capAmount = gameController.globalHelperGetBaseStake() * 5000;
      const isCapped = this._currentCashWinnings >= capAmount;

      if (isCapped === true) {
        await this.showMaxGambleReachedPopup();
      }

      if (aboveStake) {
        showBigWin = bigWin.willTriggerBigWin(this._currentCashWinnings, gameController.globalHelperGetBaseStake());
      }

      if (showBigWin) {
        bigWin.start(
          this._currentCashWinnings,
          isCapped,
          null,
          null,
          () => {
            this.end();
          },
          'gamble'
        );
      } else {
        this.end();
      }
    }

    end() {
      musicManager.stopGambleLoop();

      if (this._resultShownCb) {
        this._resultShownCb();
      }

      if (this._recover) {
        if (this._currentPrizeType === 'cash') {
          this.stateMachine.switchState('IDLE');
          resourceManager.getController('inputOverlord').setState('enabled');
          // is the next line is available when you collect free spins, all hell breaks lose
          gdk.getNextGameOutcome(function () {}); // !!! this has to be here otherwise the gameComplete event isnt queued
        }

        this._recover = false;
        this._recoverSubsequent = false;
        this._removeRecovery = false;
      } else {
        if (this._currentPrizeType === 'cash' || !this._currentWin) {
          this.stateMachine.switchState('IDLE');
          resourceManager.getController('inputOverlord').setState('enabled');
        }
      }
    }

    onGambleRisk(task = undefined) {
      this.disableBonusGambleOptions();
      this.disableCashGambleOptions();

      if (this._recover) {
        const command = task.data.command;
        const bonus = command.includes('BONUS');

        let type;

        if (bonus) {
          this._currentBonusLevel = this._bonusCommands.findIndex((element) => element.includes(command));
          type = 'bonus';
        } else {
          this._currentCashLevel = this._cashCommands.findIndex((element) => element.includes(command));
          type = 'cash';
        }

        if (this._bonusAvailable) {
          this.highlightBonusOption(this._currentBonusLevel, true);
          this._nextFreeSpins = this._bonusOptions[this._currentBonusLevel].freeSpinsWon;
          this._bonusGambleText.setTranslationParameters(this._nextFreeSpins);
        } else {
          this._nextFreeSpins = undefined;
          this._bonusGambleText.setTranslationPhrase('t_maxSpinsReached');
        }

        if (this._cashAvailable) {
          this.highlightCashOption(this._currentCashLevel, true);
          this._nextCash = this._cashOptions[this._currentCashLevel].winAmount;
          this._cashGambleText.setText(gdk.formatCurrency(this._nextCash));
        } else {
          this._nextCash = undefined;
          this._cashGambleText.setTranslationPhrase('t_maxGambleReached');
        }

        this._currentPrizeType = type;

        this.setupWheel();
        this.checkDirectionButton('bonus');
        this.checkDirectionButton('cash');

        this.fadeWheel(true, type);
      }

      const isBonus = this._currentPrizeType === 'bonus';
      const commands = isBonus ? this._bonusCommands : this._cashCommands;
      const level = isBonus ? this._currentBonusLevel : this._currentCashLevel;

      if (this._hasGambled) {
        this._commandCheck = true;
      }

      this._collectButton.interactive = false;
      this.resetFinger();

      this._callback(commands[level]);

      if (this._recoverSubsequent) {
        gdk.getNextGameOutcome(function () {});
      }

      this._hasGambled = true;

      this._bonusSpinner.interactive = false;
      this._cashSpinner.interactive = false;

      this.setButtonActive(this._bonusPrev, false);
      this.setButtonActive(this._bonusNext, false);
      this.setButtonActive(this._cashPrev, false);
      this.setButtonActive(this._cashNext, false);
    }

    resetFinger() {
      if (this.fingerTimer !== undefined) {
        timerManager.stop(this.fingerTimer);
        this.fingerTimer = undefined;
      }

      this.moveFinger = false;
      this.fingerMoving = false;
      this._bonusEmitter.particleEmitter.emit = false;
      this._cashEmitter.particleEmitter.emit = false;
      this.stateMachine.switchState('IDLE');
    }

    onCommittedToGamble(type) {
      const sp = gdk.getServerParser();
      if (!this._buttonsActive || sp._inReplayMode || sp._inRewatchMode || this._recover) return;

      const avail = type === 'cash' ? this._cashAvailable : this._bonusAvailable;

      if (!avail) {
        return;
      }

      this._currentPrizeType = type;

      this.fadeWheel(true, type);

      messageBus.postImmediate('Gamble:Risk');
    }

    onClickedToContinue(ignoreButtonsInactive = false) {
      if (!ignoreButtonsInactive && !this._buttonsActive) return;

      this._buttonsActive = false;
      this._collectButton.alpha = 0.5;

      this._callback('COLLECT');
    }

    async spinOptionsPanelDown(panel) {
      await game.tweenFromToAsync(
        panel.scale,
        {
          x: 1,
        },
        {
          x: 0,
          duration: 0.15,
        }
      );
    }

    async spinOptionsPanelUp(panel) {
      await game.tweenFromToAsync(
        panel.scale,
        {
          x: 0,
        },
        {
          x: 1,
          duration: 0.15,
        }
      );
    }

    async spinCashOptionsPanelDown(index) {
      await this.spinOptionsPanelDown(this._cashGambleOptionPanels[index]);
    }

    async spinCashOptionsPanelUp(index) {
      await this.spinOptionsPanelUp(this._cashGambleOptionPanels[index]);
    }

    async spinBonusOptionsPanelDown(index) {
      await this.spinOptionsPanelDown(this._bonusGambleOptionPanels[index]);
    }

    async spinBonusOptionsPanelUp(index) {
      await this.spinOptionsPanelUp(this._bonusGambleOptionPanels[index]);
    }

    async presentNewCashOption(cashGambleOptions, index) {
      let i = index;

      let changed = true;
      if (
        cashGambleOptions[i] &&
        gdk.formatCurrency(cashGambleOptions[i].winAmount) === this._cashGambleOptionTexts[i].text
      ) {
        // data is the same
        changed = false;
      }

      if (changed === true) {
        await this.spinCashOptionsPanelDown(index);

        if (cashGambleOptions[i]) {
          this._cashGambleOptionTexts[i].setText(gdk.formatCurrency(cashGambleOptions[i].winAmount));
        } else {
          // we dont have an entry for this panel anymore
          // hide it
          this._cashGambleOptionTexts[i].setText('');
          this._cashGambleOptionPanels[i].visible = false;
        }

        await this.spinCashOptionsPanelUp(index);
      }
    }

    async presentNewBonusOption(bonusGambleOptions, index) {
      let i = index;

      let changed = true;
      if (bonusGambleOptions[i] && bonusGambleOptions[i].freeSpinsWon == this._bonusGambleOptionTexts[i].text) {
        // data is the same
        changed = false;
      }

      if (changed === true) {
        await this.spinBonusOptionsPanelDown(index);

        if (bonusGambleOptions[i]) {
          this._bonusGambleOptionTexts[i].setText(bonusGambleOptions[i].freeSpinsWon);
        } else {
          // we dont have an entry for this panel anymore
          // hide it
          this._bonusGambleOptionTexts[i].setText('');
          this._bonusGambleOptionPanels[i].visible = false;
        }

        await this.spinBonusOptionsPanelUp(index);
      }
    }

    async presentNewCashOptions(cashGambleOptions) {
      // we need to loop over each option
      const promises = [];
      for (let i = 0; i < this._cashGambleOptionPanels.length; i++) {
        promises.push(this.presentNewCashOption(cashGambleOptions, i));
        await timerManager.delayAsync(100);
      }

      await Promise.all(promises);
    }

    async presentNewBonusOptions(bonusGambleOptions) {
      // we need to loop over each option
      const promises = [];
      for (let i = 0; i < this._bonusGambleOptionPanels.length; i++) {
        promises.push(this.presentNewBonusOption(bonusGambleOptions, i));
        await timerManager.delayAsync(100);
      }

      await Promise.all(promises);
    }

    async presentNewOptions(prizeType, bonusGambleOptions, cashGambleOptions) {
      // perhaps we should do both
      await Promise.all([
        this.presentNewCashOptions(cashGambleOptions),
        this.presentNewBonusOptions(bonusGambleOptions),
      ]);

      // if (prizeType === 'cash') {
      //   // need to animate the cash amount updating on the beanstalk
      //   await this.presentNewCashOptions(cashGambleOptions);
      // } else {
      //   // must be bonus
      //   // need to animate the freeSpins amount updating on the beanstalk
      //   await this.presentNewBonusOptions(bonusGambleOptions);
      // }
    }

    async start(bonusGambleOptions, cashGambleOptions, animatingIn = false) {
      if (!animatingIn) {
        // im assuming we have had a gamble and we have has success
        await this.presentNewOptions(this._currentPrizeType, bonusGambleOptions, cashGambleOptions);
        // should be safe to enable all, any that arent used, are hidden
        if (!this._recover) {
          this.enableBonusGambleOptions();
          this.enableCashGambleOptions();
        }
      }

      // shouldnt we also reset the cash level?
      this._currentBonusLevel = 0;

      this._buttonsActive = true;

      // this hides all the ui buttons apart from mute
      resourceManager.getController('inputOverlord').setState('gamble');

      this._gambleContainer.visible = true;
      this.visible = true;

      this.fadeWheel(false, 'cash');
      this.fadeWheel(false, 'bonus');

      this._bonusOptions = bonusGambleOptions;
      this._cashOptions = cashGambleOptions;

      this.toggleTouchText(true);

      if (bonusGambleOptions.length === 0) {
        this._bonusAvailable = false;
        this._nextFreeSpins = undefined;
      } else {
        this._bonusAvailable = true;

        this._currentBonusLevel = Math.min(this._currentBonusLevel, bonusGambleOptions.length - 1);
        this._nextFreeSpins = bonusGambleOptions[this._currentBonusLevel].freeSpinsWon;
        this.highlightBonusOption(this._currentBonusLevel);
      }

      if (cashGambleOptions.length === 0) {
        this._cashAvailable = false;
        this._nextCash = undefined;
      } else {
        this._cashAvailable = true;

        this._currentCashLevel = Math.min(this._currentCashLevel, cashGambleOptions.length - 1);
        this._nextCash = cashGambleOptions[this._currentCashLevel].winAmount;
        this.highlightCashOption(this._currentCashLevel);
      }

      this._maxBonusLevel = bonusGambleOptions.length;
      if (this._maxBonusLevel > this._bonusGambleOptionPanels.length) {
        this._maxBonusLevel = this._bonusGambleOptionPanels.length;
      }
      this._maxCashLevel = cashGambleOptions.length;

      this._collectButton.visible = !this._recover;

      // this.showPlaque();

      if (this._maxBonusLevel === 0) {
        this._bonusGambleText.setTranslationPhrase('t_maxSpinsReached');
        this._bonusSpinner.interactive = false;

        this.setButtonActive(this._bonusPrev, false);
        this.setButtonActive(this._bonusNext, false);
      } else {
        this._bonusGambleText.setTranslationPhrase('t_numFreeSpins');
        this._bonusGambleText.setTranslationParameters(this._nextFreeSpins);
        this._bonusSpinner.interactive = true;
      }

      if (this._maxCashLevel === 0) {
        this._cashGambleText.setTranslationPhrase('t_maxGambleReached');
        this._cashGambleText.setMaxWidth(260);
        this._cashSpinner.interactive = false;

        this.setButtonActive(this._cashPrev, false);
        this.setButtonActive(this._cashNext, false);
      } else {
        this._cashGambleText.setText(gdk.formatCurrency(this._nextCash));
        this._cashSpinner.interactive = true;
      }

      if (this._maxBonusLevel === 0 && this._maxCashLevel === 0) {
        this.onClickedToContinue();
      }

      this.checkDirectionButton('bonus');
      this.checkDirectionButton('cash');

      // this._gambleDisclaimer.visible = false;

      if (animatingIn) {
        timerManager.addTimeout(1100, () => {
          if (this._recover) {
            messageBus.postImmediate('Gamble:WaitForInput');
          }

          this._collectButton.interactive = !this._recover;
          this._cashSpinner.interactive = !this._recover;
          this._bonusSpinner.interactive = !this._recover;
        });
      } else {
        if (this._recover) {
          messageBus.postImmediate('Gamble:WaitForInput');
        }

        this._collectButton.interactive = !this._recover;
        this._cashSpinner.interactive = !this._recover;
        this._bonusSpinner.interactive = !this._recover;
      }

      this.setupWheel();
    }

    setupWheel() {
      // === Cash Wheel
      if (this._cashAvailable) {
        const cashWinChance = this._cashOptions[this._currentCashLevel].winChance;
        const cashLoseChance = 1 - cashWinChance;

        const cashWinPercentage = (cashWinChance * 100) / (cashWinChance + cashLoseChance) / 100;
        const cashLosePercentage = 1 - cashWinPercentage;

        this._cashSpinner.clear();

        this._cashStartAngle = -(cashLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._cashLoseEndAngle = (cashLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._cashWinStartAngle = this._cashLoseEndAngle;
        this._cashWinEndAngle = this._cashLoseEndAngle + cashWinPercentage * Math.PI * 2;
      } else {
        this._cashStartAngle = 0;
        this._cashLoseEndAngle = Math.PI * 2;
        this._cashWinStartAngle = 0;
        this._cashWinEndAngle = 0;

        this.fadeWheel(true, 'bonus');
      }

      // Winning arc
      this._cashSpinner.beginFill(0x00c800);
      this._cashSpinner.lineStyle(0, 0xffffff);
      this._cashSpinner.moveTo(0, 0);
      this._cashSpinner.arc(0, 0, 128, this._cashWinStartAngle, this._cashWinEndAngle); // cx, cy, radius, startAngle, endAngle
      this._cashSpinner.endFill();

      // Losing arc
      this._cashSpinner.beginFill(0xc80000);
      this._cashSpinner.lineStyle(0, 0xffffff);
      this._cashSpinner.moveTo(0, 0);
      this._cashSpinner.arc(0, 0, 128, this._cashStartAngle, this._cashLoseEndAngle); // cx, cy, radius, startAngle, endAngle
      this._cashSpinner.endFill();

      // === Bonus Wheel
      if (this._bonusAvailable) {
        const bonusWinChance = this._bonusOptions[this._currentBonusLevel].winChance;
        const bonusLoseChance = 1 - bonusWinChance;

        const bonusWinPercentage = (bonusWinChance * 100) / (bonusWinChance + bonusLoseChance) / 100;
        const bonusLosePercentage = 1 - bonusWinPercentage;

        this._bonusSpinner.clear();

        this._bonusStartAngle = -(bonusLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._bonusLoseEndAngle = (bonusLosePercentage * Math.PI * 2) / 2 + Math.PI / 2;
        this._bonusWinStartAngle = this._bonusLoseEndAngle;
        this._bonusWinEndAngle = this._bonusLoseEndAngle + bonusWinPercentage * Math.PI * 2;
      } else {
        this._bonusStartAngle = 0;
        this._bonusLoseEndAngle = Math.PI * 2;
        this._bonusWinStartAngle = 0;
        this._bonusWinEndAngle = 0;

        this.fadeWheel(true, 'cash');
      }

      // Winning arc
      this._bonusSpinner.beginFill(0x00c800);
      this._bonusSpinner.lineStyle(0, 0xffffff);
      this._bonusSpinner.moveTo(0, 0);
      this._bonusSpinner.arc(0, 0, 128, this._bonusWinStartAngle, this._bonusWinEndAngle); // cx, cy, radius, startAngle, endAngle
      this._bonusSpinner.endFill();

      // Losing arc
      this._bonusSpinner.beginFill(0xc80000);
      this._bonusSpinner.lineStyle(0, 0xffffff);
      this._bonusSpinner.moveTo(0, 0);
      this._bonusSpinner.arc(0, 0, 128, this._bonusStartAngle, this._bonusLoseEndAngle); // cx, cy, radius, startAngle, endAngle
      this._bonusSpinner.endFill();
    }

    spinToResult(task, callback) {
      this._currentWin = task.data.won;
      this._resultShownCb = callback;
      this._collectButton.visible = false;
      this._buttonsActive = false;

      this.toggleTouchText(false);

      this.disableBonusGambleOptions();
      this.disableCashGambleOptions();

      this._cashSpinner.interactive = false;
      this._bonusSpinner.interactive = false;

      this.setButtonActive(this._bonusPrev, false);
      this.setButtonActive(this._bonusNext, false);
      this.setButtonActive(this._cashPrev, false);
      this.setButtonActive(this._cashNext, false);

      let totalSpins = 4 + game.randomNumberBetween(0, 1);
      console.log('totalSpins = ' + totalSpins);
      let spinAngle = undefined;
      let safetyAngle = 0.087;

      const isBonus = this._currentPrizeType === 'bonus';

      const startAngle = isBonus ? this._bonusStartAngle : this._cashStartAngle;
      const startWinAngle = isBonus ? this._bonusWinStartAngle : this._cashWinStartAngle;
      const loseAngle = isBonus ? this._bonusLoseEndAngle : this._cashLoseEndAngle;
      const winEndAngle = isBonus ? this._bonusWinEndAngle : this._cashWinEndAngle;

      if (this._currentWin) {
        spinAngle =
          startWinAngle +
          safetyAngle +
          gameController.rng.nextFloat() * (winEndAngle - safetyAngle - (startWinAngle + safetyAngle));
      } else {
        spinAngle =
          startAngle +
          safetyAngle +
          gameController.rng.nextFloat() * (loseAngle - safetyAngle - (startAngle + safetyAngle));
      }

      const otherSpin = startAngle + safetyAngle + task.data.otherGambleSpinStop * (Math.PI / 180);
      const totalOtherSpin = totalSpins * Math.PI * 2.0 + otherSpin + Math.PI / 2;

      let totalSpinDistance = totalSpins * Math.PI * 2.0 + spinAngle + Math.PI / 2;
      let totalTime = 900 * totalSpins;

      let self = this;

      const bonusSpinDis = this._currentPrizeType === 'bonus' ? totalSpinDistance : totalOtherSpin;

      timerManager.addTimeout(totalTime, function () {
        soundManager.stop('gambleSpin');
        self.resultLanded(task);
      });

      soundManager.play('gambleSpin');

      // === Bonus
      if (this._bonusAvailable) {
        this._bonusEmitter.particleEmitter.emit = true;

        timerManager.addTimer(
          totalTime,
          function (progress) {
            var easedRotation = Math.sqrt(1 - Math.pow(progress - 1, 2)) * bonusSpinDis;

            self._bonusArrow.rotation = easedRotation;

            var emitterAngle = easedRotation - Math.PI / 2;

            var xx = 120 * Math.cos(emitterAngle);
            var yy = 120 * Math.sin(emitterAngle);

            self._bonusEmitter.particleEmitter.spawnPos.x = self._bonusArrow.position.x + xx;
            self._bonusEmitter.particleEmitter.spawnPos.y = self._bonusArrow.position.y + yy;
          },
          function () {}
        );
      }

      // === Cash
      if (this._cashAvailable) {
        this._cashEmitter.particleEmitter.emit = true;

        const cashSpinDis = this._currentPrizeType === 'cash' ? totalSpinDistance : totalOtherSpin;

        timerManager.addTimer(
          totalTime,
          function (progress) {
            var easedRotation = Math.sqrt(1 - Math.pow(progress - 1, 2)) * cashSpinDis;

            self._cashArrow.rotation = easedRotation;

            var emitterAngle = easedRotation - Math.PI / 2;

            var xx = 120 * Math.cos(emitterAngle);
            var yy = 120 * Math.sin(emitterAngle);

            self._cashEmitter.particleEmitter.spawnPos.x = self._cashArrow.position.x + xx;
            self._cashEmitter.particleEmitter.spawnPos.y = self._cashArrow.position.y + yy;
          },
          function () {}
        );
      }
    }

    resultLanded(task) {
      // musicManager.gambleLand();

      this._bonusEmitter.particleEmitter.emit = false;
      this._cashEmitter.particleEmitter.emit = false;

      if (this._currentWin) {
        soundManager.play('gambleWin');

        this.setCurrentPrize(this._currentPrizeType, task.data.won, this._nextFreeSpins);

        // this.animateWinLoseText(true, this._currentPrizeType);

        this._resultText.setTranslationPhrase('t_wellDone');
        this._resultTextP.setTranslationPhrase('t_wellDone');
      } else {
        this._resultText.setTranslationPhrase('t_betterLuckNextTime');
        this._resultTextP.setTranslationPhrase('t_betterLuckNextTime');

        // gameController.stopCyclingWins();

        this._hasGambled = false;

        gameController.totalWinnings = 0;

        // this.animateWinLoseText(false, this._currentPrizeType);

        this._currentPrizeText.setText('');

        soundManager.play('gambleLose');

        this.stateMachine.switchState('IDLE');
      }

      this._resultText.renderable = true;
      this._resultText.alpha = 0;
      this._resultTextP.renderable = true;
      this._resultTextP.alpha = 0;

      gsap.to([this._resultText, this._resultTextP], { duration: 0.2, alpha: 1 });

      // allow time to see results - more time on a lose
      let self = this;
      timerManager.addTimer(
        1500,
        function () {},
        function () {
          gsap.to([self._resultText, self._resultTextP], {
            duration: 0.2,
            alpha: 0,
            onComplete: () => {
              self._resultText.renderable = false;
              self._resultTextP.renderable = false;
            },
          });

          timerManager.addTimer(
            100,
            function () {},
            function () {
              if (self._currentWin) {
                const bonus = task.data.bonusGambleOptions;
                const cash = task.data.cashGambleOptions;

                if (self._recover) {
                  self._recoverSubsequent = true;
                }

                if (self.checkContinueGamble(bonus, cash)) {
                  self.start(bonus, cash);
                } else {
                  // no options to continue - have we hit the max?
                  self.onClickedToContinue(true);
                  // hack because we have auto collected
                  // we really should drop into start which would pick up this waitforinput
                  if (self._recover) {
                    messageBus.postImmediate('Gamble:WaitForInput');
                  }
                  // self.onDecisionMade(task, task.data.resultCallback, 'COLLECT');
                }
              } else {
                self.gambleLost();
              }
            }
          );
        }
      );
    }

    checkContinueGamble(bonus, cash) {
      if (bonus.length > 0 || cash.length > 0) {
        return true;
      } else {
        return false;
      }
    }

    // animateWinLoseText(win, type) {
    //   let obj = undefined;

    //   if (type === 'bonus') {
    //     if (win) {
    //       obj = this._bonusWinText;
    //     } else {
    //       obj = this._bonusLoseText;
    //     }
    //   } else {
    //     if (win) {
    //       obj = this._cashWinText;
    //     } else {
    //       obj = this._cashLoseText;
    //     }
    //   }

    //   const duration = 0.7;

    //   obj.visible = true;
    //   obj.scale.set(0.5);
    //   obj.alpha = 0;

    //   gsap.to(obj.scale, {
    //     duration,
    //     alpha: 1,
    //     x: 1,
    //     y: 1,
    //     ease: 'power4.out',
    //     yoyo: true,
    //     repeat: 1,
    //     onComplete: () => {
    //       obj.visible = false;
    //     },
    //   });
    // }

    gambleLost() {
      const self = this;

      // gameController.lastPayWinsData = undefined;

      gameData.winningsMeter.set(0);

      musicManager.stopGambleLoop();
      this.exitAnim();

      timerManager.addTimeout(500, function () {
        if (self._resultShownCb) {
          self._resultShownCb();
        }
      });
    }

    setCurrentPrize(type, cash, freeSpins) {
      if (type === 'cash') {
        this._currentPrizeText.setText(gdk.formatCurrency(cash));
        this._currentCashWinnings = cash;
      } else if (type === 'bonus') {
        this._currentPrizeText.setText(freeSpins + ' FREE SPINS');
      }
      // this._currentPrizeText.setMaxWidth(260);
    }

    fadeOut(object, duration = 0.3, delay = 0, cb = undefined) {
      if (object) {
        gsap.to(object, {
          duration,
          delay,
          alpha: 0,
          onComplete: () => {
            object.visible = false;
            if (cb != undefined) {
              cb();
            }
          },
        });
      } else {
        // dont have a valid object
      }
    }

    fadeIn(object, duration = 0.3, delay = 0, cb = undefined) {
      if (object) {
        object.alpha = 0;
        object.visible = true;

        gsap.to(object, {
          duration,
          delay,
          alpha: 1,
          onComplete: () => {
            if (cb != undefined) {
              cb();
            }
          },
        });
      } else {
        // not a valid object
      }
    }

    enterAnim() {
      musicManager.playGambleLoop();

      this.fadeIn(this, 0.3, 0.3, () => {
        this.enableBonusGambleOptions();
        this.enableCashGambleOptions();
      });
      this.fadeOut(autoplayManager.dialog.buttonGlow);
      this.fadeOut(resourceManager.get('bgTrail'));
      this.fadeOut(resourceManager.get('slotContainer'));
      this.fadeOut(resourceManager.get('outcomesPanel:OutcomesPanel'));
      this.fadeOut(resourceManager.get('slotContainer:logoContainer'), 0.3, 0, () => {
        if (autoplayManager.dialog.buttonGlow) {
          autoplayManager.dialog.buttonGlow.visible = false;
        }
      });
    }

    exitAnim(cb) {
      this._buttonsActive = false;

      if (autoplayManager.isAutoplayEnabled()) {
        autoplayManager.dialog.buttonGlow.visible = true;
        this.fadeIn(autoplayManager.dialog.buttonGlow);
      }
      this.fadeIn(resourceManager.get('bgTrail'), 0.3);
      this.fadeIn(resourceManager.get('slotContainer:logoContainer'), 0.3);
      this.fadeIn(resourceManager.get('outcomesPanel:OutcomesPanel'), 0.3);
      this.fadeIn(resourceManager.get('slotContainer'), 0.3, 0, () => {
        // this._spinnerTimeline = undefined;

        if (cb) {
          cb();
        }

        resourceManager.getController('inputOverlord').setState('enabled');
      });

      this.fadeOut(this, 0.3);
    }

    selectButtonPressed(type, direction) {
      if (!this._buttonsActive) return;

      if (type === 'bonus') {
        this._currentBonusLevel += direction;
        this._currentBonusLevel = Math.max(0, Math.min(this._currentBonusLevel, this._maxBonusLevel - 1));
        this.highlightBonusOption(this._currentBonusLevel);

        this._nextFreeSpins = this._bonusOptions[this._currentBonusLevel].freeSpinsWon;

        if (this._bonusAvailable) {
          this._bonusGambleText.setTranslationParameters(this._nextFreeSpins);
        } else {
          this._bonusGambleText.setText('');
        }

        // this.showPlaque();
      } else if (type === 'cash') {
        this._currentCashLevel += direction;
        this._currentCashLevel = Math.max(0, Math.min(this._currentCashLevel, this._maxCashLevel - 1));
        this.highlightCashOption(this._currentCashLevel);

        this._nextCash = this._cashOptions[this._currentCashLevel].winAmount;

        if (this._cashAvailable) {
          this._cashGambleText.setText(gdk.formatCurrency(this._nextCash));
        } else {
          this._cashGambleText.setText('');
        }
      }

      if (direction === 1) {
        soundManager.play(this._selectSounds[1]);
      } else {
        soundManager.play(this._selectSounds[0]);
      }

      this.checkDirectionButton(type);
      this.setupWheel();
    }

    // showPlaque() {
    //   if (this._nextFreeSpins === 3) {
    //     this._upgrade1.visible = true;
    //     this._upgrade2.visible = false;
    //   } else if (this._nextFreeSpins === 4) {
    //     this._upgrade1.visible = false;
    //     this._upgrade2.visible = true;
    //   } else {
    //     this._upgrade1.visible = false;
    //     this._upgrade2.visible = false;
    //   }
    // }

    checkDirectionButton(type) {
      if (type === 'bonus') {
        this.setButtonActive(this._bonusPrev, this._currentBonusLevel !== 0);
        this.setButtonActive(
          this._bonusNext,
          this._currentBonusLevel !== this._maxBonusLevel - 1 && this._maxBonusLevel > 0
        );
      } else if (type === 'cash') {
        this.setButtonActive(this._cashPrev, this._currentCashLevel !== 0);
        this.setButtonActive(
          this._cashNext,
          this._currentCashLevel !== this._maxCashLevel - 1 && this._maxCashLevel > 0
        );
      }

      if (this._recover) {
        this.disableBonusGambleOptions();
        this.disableCashGambleOptions();

        this._cashPrev.interactive = false;
        this._cashNext.interactive = false;
        this._bonusPrev.interactive = false;
        this._bonusNext.interactive = false;
      }
    }

    fadeWheel(fade, type) {
      const wheel = type === 'bonus' ? this._cashSpinnerBacking : this._bonusSpinnerBacking;

      wheel.alpha = fade ? 0.3 : 0;
    }

    setButtonActive(button, active) {
      button.interactive = active;
      button.alpha = active ? 1 : 0.5;
    }

    highlightBonusOption(currentBonusLevel, dontEmit = false) {
      for (let i = 0; i < this._bonusGambleOptionPanels.length; i++) {
        const onOrOff = i === currentBonusLevel ? 1 : 0;
        this._bonusGambleOptionPanels[i].gotoAndStop(onOrOff);

        if (onOrOff === 1 && this._bonusGambleOptionPanelEmitters[i] && dontEmit !== true) {
          this._bonusGambleOptionPanelEmitters[i].particleEmitter.emit = true;
        }
      }
    }

    highlightCashOption(currentCashLevel, dontEmit = false) {
      for (let i = 0; i < this._cashGambleOptionPanels.length; i++) {
        const onOrOff = i === currentCashLevel ? 1 : 0;
        this._cashGambleOptionPanels[i].gotoAndStop(onOrOff);

        if (onOrOff === 1 && this._cashGambleOptionPanelEmitters[i] && dontEmit !== true) {
          this._cashGambleOptionPanelEmitters[i].particleEmitter.emit = true;
        }
      }
    }

    prepareOptions(currentBonusLevel, currentCashLevel, data) {
      const maxCashOptions = this._cashCommands.length;
      const maxBonusOptions = this._bonusCommands.length;

      const bonusOptionsCap = this._bonusGambleOptionPanels.length;
      for (let i = 0; i < maxBonusOptions; i++) {
        if (i >= bonusOptionsCap) {
          // we only have 4 options to show
          // so ignore anything else
        } else {
          this._bonusGambleOptionPanels[i].gotoAndStop(i === currentBonusLevel ? 1 : 0);
          this._bonusGambleOptionTexts[i].setText('');

          if (i < data.bonusGambleOptions.length) {
            this._bonusGambleOptionPanels[i].visible = true;
            this._bonusGambleOptionTexts[i].setText(data.bonusGambleOptions[i].freeSpinsWon);
          } else {
            // dont have valid data for this one
            // hide it
            this._bonusGambleOptionPanels[i].visible = false;
          }
        }
      }

      for (let i = 0; i < maxCashOptions; i++) {
        this._cashGambleOptionPanels[i].gotoAndStop(i === currentCashLevel ? 1 : 0);
        this._cashGambleOptionTexts[i].setText('');

        if (i < data.cashGambleOptions.length) {
          this._cashGambleOptionPanels[i].visible = true;
          this._cashGambleOptionTexts[i].setText(gdk.formatCurrency(data.cashGambleOptions[i].winAmount));
        } else {
          // dont have valid data for this one
          // hide it
          this._cashGambleOptionPanels[i].visible = false;
        }
      }
    }
  }

  let gambleSpinCreator = function (json) {
    return new GambleSpin();
  };

  let gambleSpinInitialiser = function (json, disclaimer) {
    disclaimer.initialise();
  };

  let gambleSpinFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('GambleSpin', gambleSpinCreator, gambleSpinInitialiser, gambleSpinFilesRequired);
})();
